<template>
  <div id="app" class="font-sans antialiased text-gray-800 h-screen w-screen overflow-hidden">
    <Layout v-if="!isAuthRoute">
      <router-view />
    </Layout>
    <router-view v-else />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'

export default {
  name: 'App',
  components: {
    Layout
  },
  computed: {
    isAuthRoute() {
      // 不需要布局的路由，如登录、注册页面、可视化大屏页面、analytics页面
      const authRoutes = ['/login', '/register', '/data-visualization'];
      const isAnalyticsRoute = this.$route.path.startsWith('/analytics/');
      const isDataManagementRoute = this.$route.path.startsWith('/data-management/');
      return authRoutes.includes(this.$route.path) || isAnalyticsRoute || isDataManagementRoute;
    }
  }
}
</script>

<style>
/* All styles have been moved to Tailwind classes */
</style> 